import { render } from "./addNewUserPopup.vue?vue&type=template&id=0865edcc&scoped=true"
import script from "./addNewUserPopup.vue?vue&type=script&lang=js"
export * from "./addNewUserPopup.vue?vue&type=script&lang=js"

import "./addNewUserPopup.vue?vue&type=style&index=0&id=0865edcc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0865edcc"]])

export default __exports__